/* eslint-disable
    func-names,
    max-len,
    no-param-reassign,
    no-underscore-dangle,
    no-use-before-define,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = [
  'Model',
  '$sce',
  'Validate',
  '$filter',
  'Relation',
  'DocumentVM',
  'benchLocation',
  '_',
];

const factory = function (Model, $sce, Validate, $filter, Relation, DocumentVM, benchLocation, _) {
  class Document extends Model {
    static taxDocumentTypesListMap = [
      { value: 'UNDEFINED', name: 'Undefined or unknown' },

      { value: 'ID', name: 'Owner ID Document' },
      { value: 'SPOUSE_ID', name: 'Spouse ID Document' },

      { value: 'FORM_1120', name: 'Form 1120' },
      { value: 'FORM_1120S', name: 'Form 1120s' },
      { value: 'FORM_1040', name: 'Form 1040' },
      { value: 'FORM_1040_SCHEDULE_C', name: 'Form 1040 Schedule C' },
      { value: 'FORM_1065', name: 'Form 1065' },

      { value: 'ARTICLES_OF_INCORPORATION', name: 'Articles of Incorporation' },
      { value: 'ARTICLES_OF_ORGANIZATION', name: 'Articles of Organization' },
      { value: 'EIN_ACCEPTANCE_FORM', name: 'EIN Acceptance letter' },
      { value: 'NOTICE_CP261', name: 'Notice CP261 (385C)' },

      { value: 'YEF', name: 'Year End Financial (YEF)' },
      { value: 'SUPPLEMENTAL', name: 'Supplemental document, needed to file' },
    ];

    static initClass() {
      this.prototype.$resource = 'document';
      this.prototype.$viewModelType = DocumentVM;

      // default attributes
      this.prototype.id = null;
      this.prototype.clientId = null;
      this.prototype.fileId = null;
      this.prototype.file = null;
      this.prototype.vendor = '';
      this.prototype.attributes = {};
      this.prototype.documentDate = '';
      this.prototype.currencyId = null;
      this.prototype.notes = '';
      this.prototype.currencyExchangeRate = null;
      this.prototype.dataEntries = [];
      this.prototype.documentType = 'RECEIPT'; // DOCUMENT / TRANSACTIONAL / RECEIPT
      this.prototype.expenseRevenueType = null;
      this.prototype.value = 'Expense';
      this.prototype.canChangeFinancialDocumentType = true;
      this.prototype.canApplyUnlink = false;
      this.prototype.hasUnlinkHistory = false;
      this.prototype.relatedJE = null;
      this.prototype.salesTaxApplicationStatus = 'NOT_APPLICABLE';
      this.prototype.amount = 0;
      this.prototype.taxAmount = null;
      this.prototype.jeHistory = [];

      // Relations
      this.prototype.$file = Relation('File', 'fileId');
      this.prototype.$dpFile = Relation('File', 'dataProcessingMetadata.dpFileId');
      this.prototype.$ledger = Relation('Ledger', 'attributes.ledgerAccountId');
      this.prototype.$addon = Relation('AddOn', 'attributes.documentAddOnId');

      this.prototype.$modelValidators = {
        openBeforeClose(data) {
          const { openingDate } = data.attributes;
          const { closingDate } = data.attributes;

          if (openingDate && closingDate) {
            return Date.parse(openingDate) <= Date.parse(closingDate);
          }
          return true;
        },
        receiptNonZeroSum(data) {
          const { documentType } = data;
          const balance = Document.getBalance(data);
          if (documentType === 'RECEIPT' && balance === 0) {
            return false;
          }
          return true;
        },
        TransactionalMinDataEntries(data) {
          const { documentType } = data;
          const numEntries = (data.dataEntries != null ? data.dataEntries.length : undefined) || 0;
          if (documentType === 'TRANSACTIONAL' && numEntries < 2) {
            return false;
          }
          return true;
        },
        TransactionalZeroSum(data) {
          const { documentType } = data;
          const balance = Document.getBalance(data);
          if (documentType === 'TRANSACTIONAL' && balance > 0.01) {
            return false;
          }
          return true;
        },
      };

      this.prototype.$validators = {
        vendor: {
          required: Validate.required(),
        },
        clientId: {
          required: Validate.required(),
        },
        currencyId: {
          required: Validate.required(),
        },
        documentType: {
          required: Validate.required(),
        },
        documentDate: {
          required: Validate.required(),
          saneMinDate(date) {
            const minDate = new Date(1950, 1, 1, 0, 0, 0, 0).getTime();
            return Date.parse(date) > minDate;
          },
          saneMaxDate(date) {
            const maxDate = Date.now();
            return Date.parse(date) <= maxDate;
          },
        },
      };

      this.prototype.$errorMessages = {
        vendor: {
          required: "Vendor name can't be blank",
        },
      };

      this.prototype.$$dateAttrs = ['documentDate', 'attributes.openingDate'];

      this.prototype.$updateStatus = this.$request('PUT', 'status');

      this.prototype.$unlink = this.$request('PUT', 'unlink');
      this.prototype.$clearUnlinkHistory = this.$request('PUT', 'clear_unlink_history');
      this.prototype.$applySalesTax = this.$request('PUT', 'apply_sales_tax');
      this.prototype.$unapplySalesTax = this.$request('PUT', 'unapply_sales_tax');
    }

    getDpActions() {
      return this.dataProcessingMetadata != null
        ? this.dataProcessingMetadata.bkActions
        : undefined;
    }

    getDpNote() {
      return this.dataProcessingMetadata != null ? this.dataProcessingMetadata.note : undefined;
    }

    getDpStatus() {
      return this.dataProcessingMetadata != null ? this.dataProcessingMetadata.status : undefined;
    }

    static getBalance(data) {
      let balance = 0;
      for (const entry of data.dataEntries) {
        balance += entry.amount;
      }
      return balance;
    }

    ledgerName() {
      return this.$ledger().name;
    }

    addOnName() {
      return this.$addon().name;
    }

    getTaxDocumentTypeName() {
      const taxDocumentTypeEntry = _.find(Document.taxDocumentTypesListMap, {
        value: this.taxDocumentType,
      });
      if (taxDocumentTypeEntry) {
        return taxDocumentTypeEntry.name;
      }
      return '';
    }

    getDisplayName() {
      this.validateDisplayName();
      return this.attributes.name;
    }

    validateDisplayName() {
      // default name to file's original file name if it hasn't been set
      if (
        !(this.attributes != null ? this.attributes.name : undefined) &&
        (this.file != null ? this.file.originalFileName : undefined)
      ) {
        return this.attributes != null
          ? (this.attributes.name = this.file != null ? this.file.originalFileName : undefined)
          : undefined;
      }
    }

    getReceiptAmount() {
      return __guard__(this.dataEntries != null ? this.dataEntries[0] : undefined, x => x.amount);
    }

    isMatched() {
      return this.documentType === 'TRANSACTIONAL';
    }

    // api functions
    static $request(method, request) {
      return function (params = {}) {
        return this.$apiCall({
          method,
          url: `${this.$resource}.json/${this.$storeId()}/${request}`,
          params,
        });
      };
    }

    $serialize(data) {
      const { documentDate, documentType, dataEntries } = data;

      data.month = Number(documentDate != null ? documentDate.split('/')[0] : undefined);

      // adds sorting to transactional dataEntries by entryType 'CREDIT' > 'DEBIT'
      if (documentType === 'TRANSACTIONAL' && dataEntries.length) {
        data.dataEntries = _.orderBy(dataEntries, 'entryType');
      }

      const dates = _.reduce(
        this.$$dateAttrs,
        (acc, attr) => {
          const dateStr = _.get(data, attr);
          if (dateStr) {
            _.set(acc, attr, new Date(dateStr));
          }
          return acc;
        },
        {},
      );

      const defaults = {
        dataProcessingMetadata: {
          status: 'READY',
        },
      };

      return _(data).defaultsDeep(defaults).merge(dates).value();
    }

    $deserialize(blDocument) {
      const blDocumentCopy = angular.copy(blDocument);
      blDocumentCopy.documentDate = $filter('date')(blDocument.documentDate, 'MM/dd/yyyy');
      if ((blDocument.attributes != null ? blDocument.attributes.openingDate : undefined) != null) {
        blDocumentCopy.attributes.openingDate = $filter('date')(
          blDocument.attributes.openingDate,
          'MM/dd/yyyy',
        );
      }

      return blDocumentCopy;
    }

    $put(data) {
      return this.$apiCall({
        method: 'PUT',
        url: this.$getUrl(this.$storeId()),
        data: this.$deserialize(data),
      }).then(res => {
        if (res.data != null) {
          this.$set(this.$serialize(res.data));
        }
        return res;
      });
    }

    $fetchJeHistory() {
      return Document.$request('GET', 'jeHistory')
        .apply(this)
        .then(res => {
          this.$set({ jeHistory: res.data });
          return res;
        });
    }

    $linkTransferTo(transferID, params = {}) {
      return this.$apiCall({
        method: 'PUT',
        url: `${this.$resource}.json/${this.$storeId()}/link_transfer/${transferID}`,
        params,
      });
    }

    // convenience functions
    $getPdfPath() {
      if (this.fileId != null) {
        return $sce.trustAsResourceUrl(this.$apiService.href(`/file.json/${this.fileId}/download`));
      }
      return null;
    }

    downloadAsStatement() {
      return this.$apiService.navigate(`/file.json/${this.fileId}/downloadAsStatement/${this.id}`);
    }

    getThumbnail() {
      const rootUrl = benchLocation.apiRoot();
      if (this.file != null) {
        return `${rootUrl}${__guard__(
          this.file != null ? this.file.pages : undefined,
          x => x[0].thumbnailView,
        )}`;
      }
      return '';
    }

    getExtension() {
      return this.file != null
        ? this.file.originalFileName.split('.').slice(-1)[0].toUpperCase()
        : undefined;
    }

    download() {
      return this.$file().download();
    }

    downloadDpFile() {
      return this.$dpFile().download();
    }
  }
  Document.initClass();

  return Document;
};

factory.$inject = deps;

require('angular-sanitize');

const moduleDeps = [
  require('data/util').name,
  'ngSanitize',
  require('data/service/location').name,
  require('data/collection/transaction').name,
  require('data/model/ledger').name,
  require('data/model/addon').name,
  require('data/model/file').name,
  require('data/viewModel/document').name,
];

module.exports = angular
  .module('data.data.model.document', moduleDeps)
  .factory('Document', factory);

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}
